import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Container} from '@freckle/educator-materials/ts/components/container'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {H2} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {container, stepsList, importantList} from './get-started.module.scss'

export default function GetStarted() {
  const {t} = useSafeTranslation()

  const linkRosterSyncGuide = (
    <Link href={t('IMPORT_ROSTERING_GUIDE_URL')} target="_blank" reactRouter={false} />
  )
  const linkRosterTemplateFiles = (
    <Link
      href={t('ROSTERING_TEMPLATE_FILES_URL', {assetsUrl: PATHS.prodAssetsUrl})}
      reactRouter={false}
    />
  )

  return (
    <Container className={container}>
      <H2>{t('IMPORT_ROSTER_GET_STARTED_TITLE')}</H2>

      <SafeTrans
        i18nKey="IMPORT_ROSTER_GET_STARTED_DESCRIPTION"
        components={{
          em: <em />,
          stepsList: <ol className={stepsList} />,
          importantList: <ul className={importantList} />,
          li: <li />,
          linkRosterSyncGuide,
          linkRosterTemplateFiles
        }}
      />
    </Container>
  )
}
